// What the public pages' header and footer show, copied from the main website www.mobiliis.com (read on 1 November 2026:
// its header menu and footer). Kept here, apart from the components, so it can be tested and changed in one place.

export const SITE_URL = 'https://www.mobiliis.com';

// "Log in" and "Start free trial" in the header, after "Get in touch". Off while the live main website's header does
// not have them, so the two headers are the same; switch on the day the main website gets them. The links inside the
// pages ("Already have an account? Log in", "New to Mobiliis? Start a free trial") do not depend on this.
export const SHOW_HEADER_BUTTONS = false;

// The main website's header menu, each to its section on www.mobiliis.com
export const NAV_ITEMS = [
	{ label: 'How it works', href: SITE_URL + '/#how-it-works' },
	{ label: 'The apps', href: SITE_URL + '/#apps' },
	{ label: 'Benefits', href: SITE_URL + '/#benefits' },
	{ label: 'Screenshots', href: SITE_URL + '/#screenshots' },
	// The navy pill, as on the main website
	{ label: 'Get in touch', href: SITE_URL + '/#contact', cta: true },
];

export const LOGIN_PATH = '/authentication/login2';
export const SIGNUP_PATH = '/signup';

// The main website's footer email address, as it stores it (reversed, then base64), shown only after a click
export const EMAIL_ENCODED = 'bW9jLnNpaWxpYm9tQG5pbWRh';

export const COMPANY_LINE = 'Mobiliis Ltd, registered in Scotland SC600097';

// The address behind the footer's "Show our email address" button; '' when it cannot be read
export function revealEmail(encoded) {
	try {
		return atob(encoded).split('').reverse().join('');
	} catch (e) {
		return '';
	}
}

// Whether sign-up is open, from signup/info (laravel SignUpController: SIGNUP_ENABLED and a published Terms and
// Conditions version), as the sign-up page decides it. null or a failed load: not open.
export function signupOpen(info) {
	return !!(info && info.open && info.terms);
}

// The header's buttons on a page ('signup', 'login', 'terms'): "Log in" and "Start free trial", each left out on its
// own page; "Start free trial" only while sign-up is open; neither on the Terms page (the admin is signed in there).
// trialKind: "Start free trial" is Primary, but Secondary on the sign-in page, whose one Primary is Log In.
// Neither while SHOW_HEADER_BUTTONS is false (show: for the tests).
export function headerButtons(page, info, show = SHOW_HEADER_BUTTONS) {
	if (!show || page === 'terms') {
		return { login: false, trial: false, trialKind: 'primary' };
	}
	return {
		login: page !== 'login',
		trial: page !== 'signup' && signupOpen(info),
		trialKind: page === 'login' ? 'secondary' : 'primary',
	};
}
